import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { ConsentModel, DataConsentModel } from '../../../models/configuration/consent.model';


export class InsertConsentUseCase implements UseCase<DataConsentModel, ConsentModel> {
    constructor(private typeCanal: ConfigurationRepository) { }
    execute(
        params: DataConsentModel,
    ): Observable<ConsentModel> {
        return this.typeCanal.insertConsent(params);
    }
}
